<template>
  <div class="page-container edit-page">
    <div class="header-bar">
      <span class="header-back" @click="$router.back()">←</span>
      {{ isEdit ? '编辑地址' : '新增地址' }}
    </div>

    <div class="form-container">
      <div class="form-group">
        <label class="form-label"><span class="required">*</span> 收货人姓名</label>
        <input
          v-model="form.name"
          type="text"
          placeholder="请输入收货人姓名"
          class="form-input"
          maxlength="20"
        />
      </div>

      <div class="form-group">
        <label class="form-label"><span class="required">*</span> 手机号</label>
        <input
          v-model="form.phone"
          type="tel"
          placeholder="请输入11位手机号"
          class="form-input"
          maxlength="11"
          @input="validatePhone"
        />
      </div>

      <div class="form-group">
        <label class="form-label"><span class="required">*</span> 所在地区</label>
        <div class="region-selectors">
          <select v-model="form.province" class="form-select" @change="handleProvinceChange">
            <option value="">请选择省份</option>
            <option v-for="p in provinces" :key="p" :value="p">{{ p }}</option>
          </select>
          <select v-model="form.city" class="form-select" :disabled="!form.province" @change="handleCityChange">
            <option value="">请选择城市</option>
            <option v-for="c in cities" :key="c" :value="c">{{ c }}</option>
          </select>
          <select v-model="form.district" class="form-select" :disabled="!form.city">
            <option value="">请选择区县</option>
            <option v-for="d in districts" :key="d" :value="d">{{ d }}</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label"><span class="required">*</span> 详细地址</label>
        <textarea
          v-model="form.detail"
          placeholder="请输入详细地址（如街道、门牌号等）"
          class="form-textarea"
          rows="3"
          maxlength="100"
        ></textarea>
      </div>

      <div class="form-group switch-group">
        <label class="form-label">设为默认地址</label>
        <el-switch
          v-model="form.isDefault"
          active-color="#409EFF"
          inactive-color="#dcdfe6"
        />
      </div>
    </div>

    <div class="btn-container">
      <button class="btn-primary save-btn" :disabled="!canSave" @click="saveAddress">
        保 存
      </button>
      <button class="cancel-btn" @click="$router.back()">
        取 消
      </button>
    </div>
  </div>
</template>

<script>
import { getAddressDetail, addAddress, editAddress } from '../api/address'

export default {
  name: 'AddressEdit',
  data() {
    return {
      loading: false,
      isEdit: false,
      form: {
        id: null,
        name: '',
        phone: '',
        province: '',
        city: '',
        district: '',
        detail: '',
        isDefault: false
      },
      regionData: {
        '贵州省': {
          '贵阳市': ['南明区', '云岩区', '花溪区', '乌当区', '白云区', '观山湖区', '开阳县', '息烽县', '修文县', '清镇市'],
          '六盘水市': ['钟山区', '六枝特区', '水城区', '盘州市'],
          '遵义市': ['红花岗区', '汇川区', '播州区', '桐梓县', '绥阳县', '正安县', '道真仡佬族苗族自治县', '务川仡佬族苗族自治县', '凤冈县', '湄潭县', '余庆县', '习水县', '赤水市', '仁怀市'],
          '安顺市': ['西秀区', '平坝区', '普定县', '镇宁布依族苗族自治县', '关岭布依族苗族自治县', '紫云苗族布依族自治县'],
          '毕节市': ['七星关区', '大方县', '黔西市', '金沙县', '织金县', '纳雍县', '威宁彝族回族苗族自治县', '赫章县'],
          '铜仁市': ['碧江区', '万山区', '江口县', '玉屏侗族自治县', '石阡县', '思南县', '印江土家族苗族自治县', '德江县', '沿河土家族自治县', '松桃苗族自治县'],
          '黔西南布依族苗族自治州': ['兴义市', '兴仁市', '普安县', '晴隆县', '贞丰县', '望谟县', '册亨县', '安龙县'],
          '黔东南苗族侗族自治州': ['凯里市', '黄平县', '施秉县', '三穗县', '镇远县', '岑巩县', '天柱县', '锦屏县', '剑河县', '台江县', '黎平县', '榕江县', '从江县', '雷山县', '麻江县', '丹寨县'],
          '黔南布依族苗族自治州': ['都匀市', '福泉市', '荔波县', '贵定县', '瓮安县', '独山县', '平塘县', '罗甸县', '长顺县', '龙里县', '惠水县', '三都水族自治县']
        },
        '青海省': {
          '西宁市': ['城东区', '城中区', '城西区', '城北区', '湟中区', '大通回族土族自治县', '湟源县'],
          '海东市': ['乐都区', '平安区', '民和回族土族自治县', '互助土族自治县', '化隆回族自治县', '循化撒拉族自治县'],
          '海北藏族自治州': ['门源回族自治县', '祁连县', '海晏县', '刚察县'],
          '黄南藏族自治州': ['同仁市', '尖扎县', '泽库县', '河南蒙古族自治县'],
          '海南藏族自治州': ['共和县', '同德县', '贵德县', '兴海县', '贵南县'],
          '果洛藏族自治州': ['玛沁县', '班玛县', '甘德县', '达日县', '久治县', '玛多县'],
          '玉树藏族自治州': ['玉树市', '杂多县', '称多县', '治多县', '囊谦县', '曲麻莱县'],
          '海西蒙古族藏族自治州': ['格尔木市', '德令哈市', '茫崖市', '乌兰县', '都兰县', '天峻县']
        }
      }
    }
  },
  computed: {
    provinces() {
      return Object.keys(this.regionData)
    },
    cities() {
      if (!this.form.province) return []
      return Object.keys(this.regionData[this.form.province] || {})
    },
    districts() {
      if (!this.form.province || !this.form.city) return []
      return this.regionData[this.form.province]?.[this.form.city] || []
    },
    canSave() {
      return (
        this.form.name.trim() &&
        /^1[3-9]\d{9}$/.test(this.form.phone) &&
        this.form.province &&
        this.form.city &&
        this.form.district &&
        this.form.detail.trim()
      )
    }
  },
  created() {
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      this.loadAddressData(id)
    }
  },
  methods: {
    async loadAddressData(id) {
      this.loading = true

      try {
        const res = await getAddressDetail(id)

        if (res.data) {
          const data = res.data
          Object.assign(this.form, {
            id: parseInt(id),
            name: data.consignee_name || '',
            phone: data.consignee_phone || '',
            province: data.province || '',
            city: data.city || '',
            district: data.district || '',
            detail: data.detail_address || '',
            isDefault: !!data.is_default
          })
        }
      } catch (error) {
        console.error('加载地址详情失败:', error)
        this.$message.error(error.msg || error.message || '加载失败')
        this.$router.back()
      } finally {
        this.loading = false
      }
    },
    validatePhone() {
      this.form.phone = this.form.phone.replace(/[^\d]/g, '').slice(0, 11)
    },
    handleProvinceChange() {
      this.form.city = ''
      this.form.district = ''
    },
    handleCityChange() {
      this.form.district = ''
    },
    async saveAddress() {
      if (!this.canSave) {
        this.$message.warning('请填写完整信息')
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      })

      const addressData = {
        consignee_name: this.form.name,
        consignee_phone: this.form.phone,
        province: this.form.province,
        city: this.form.city,
        district: this.form.district,
        detail_address: this.form.detail,
        is_default: this.form.isDefault ? 1 : 0
      }

      try {
        let res
        if (this.isEdit && this.form.id) {
          res = await editAddress({ ...addressData, id: this.form.id })
        } else {
          res = await addAddress(addressData)
        }

        loading.close()
        this.$message.success(res.msg || '保存成功')
        this.$router.back()
      } catch (error) {
        loading.close()
        console.error('保存地址失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.edit-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.form-container {
  background: #fff;
  margin-top: 12px;
  padding: 8px 16px;
}

.form-group {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}

.form-group:last-child {
  border-bottom: none;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}

.required {
  color: #f56c6c;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  height: 44px;
  padding: 0 12px;
  font-size: 15px;
  color: #303133;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: all 0.3s;
}

.form-input:focus {
  background: #fff;
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.form-textarea {
  width: 100%;
  padding: 12px;
  font-size: 15px;
  color: #303133;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid transparent;
  resize: none;
  line-height: 1.6;
  transition: all 0.3s;
  font-family: inherit;
}

.form-textarea:focus {
  background: #fff;
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.region-selectors {
  display: flex;
  gap: 8px;
}

.form-select {
  flex: 1;
  height: 44px;
  padding: 0 8px;
  font-size: 14px;
  color: #303133;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
}

.form-select:focus {
  background: #fff;
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.form-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.switch-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 750px;
  margin: 0 auto;
  padding: 16px 24px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  gap: 12px;
}

.save-btn {
  flex: 1;
  height: 48px;
  font-size: 16px;
  letter-spacing: 2px;
}

.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancel-btn {
  width: 120px;
  height: 48px;
  background: #fff;
  color: #909399;
  border: 1px solid #dcdfe6;
  border-radius: 22px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn:active {
  transform: scale(0.95);
}
</style>